import { api } from "utils/api";
import type { AuthWalletResponse } from "../types";

/**
 * Async API call for wallet signature authentication
 */
const postWalletAuth = (
  walletAddress: string,
  signature: string,
  artistClaimPage?: boolean
) =>
  api.post<AuthWalletResponse>("/auth/wallet", {
    body: JSON.stringify({ walletAddress, signature, artistClaimPage }),
  });

export { postWalletAuth };
